import Separator from 'components/common/separator';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import ActivityRescheduleItemCard from './card';
import { ActivityRescheduleFormType } from '../form-type';

export default function ActivityItems() {
  const { control } = useFormContext<ActivityRescheduleFormType>();
  const { fields } = useFieldArray({
    control,
    name: 'activitySales',
    keyName: 'customId',
  });

  return (
    <>
      {fields.map((field, idx) => (
        <React.Fragment key={field.id}>
          <ActivityRescheduleItemCard parentIndex={idx} />
          <Separator gap={16} />
        </React.Fragment>
      ))}
    </>
  );
}
